import React, { useEffect, useRef, useState } from "react";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import { useHistory, useParams } from "react-router-dom";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
const Modifiers = (params) => {
  const history = useHistory();
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div className="shadowclass my-4">
              <div className="row mx-0">
                    <h4 class="event-alert w-100 mb-0">Modifiers</h4>

                    <div className="table-responsive px-0">
                      <table className="checklist-table remove-space inventory_table">
                        <thead>
                          <tr>
                            <th> Modifier Name &amp; Class </th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr class="sub_class_row">
                            <td>
                              <strong> Well Done </strong> <br /> Doneness{" "}
                            </td>
                            <td>
                              {" "}
                              <span class="green_tag"> Active </span>
                            </td>
                          </tr>
                          
                          <tr class="sub_class_row">
                            <td>
                              <strong> Well Done </strong> <br /> Doneness{" "}
                            </td>
                            <td>
                              {" "}
                              <span class="green_tag"> Active </span>
                            </td>
                          </tr>
                          
                          <tr class="sub_class_row">
                            <td>
                              <strong> Well Done </strong> <br /> Doneness{" "}
                            </td>
                            <td>
                              {" "}
                              <span class="green_tag"> Active </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default Modifiers;
